import { DecimalSchema } from "../decimal";
import { z } from "zod";

export const GeneralStatsSchema = z.object({
  totalVolumeTraded: DecimalSchema,
  totalNumberOfTrades: z.number(),
  totalRewardsReceived: DecimalSchema,
  completedCampaigns: z.number(),
  liveCampaigns: z.number(),
});

export type GeneralStats = z.infer<typeof GeneralStatsSchema>;

export const UserStatsSchema = z.object({
  totalVolumeTraded: DecimalSchema,
  totalNumberOfTrades: z.number(),
  totalRewardsReceived: DecimalSchema,
  campaignsParticipatingList: z.array(z.string()),
});
export type UserStats = z.infer<typeof UserStatsSchema>;

export const LeaderboardEntrySchema = z.object({
  defiAddress: z.string(),
  totalVolume: DecimalSchema,
  rank: z.number(),
});

export type LeaderboardEntryDto = z.infer<typeof LeaderboardEntrySchema>;

export const LeaderboardEntriesSchema = z.array(LeaderboardEntrySchema);
export type LeaderboardEntriesDto = z.infer<typeof LeaderboardEntriesSchema>;

export interface CampaignStats {
  campaignName: string;
  currentVolume: number;
  totalVolume: number;
  participantCount: number;
}

/**
 * Volume data for a single campaign (used as value in CampaignsStatsResponse)
 */
export const CampaignVolumeDataSchema = z.object({
  currentVolume: z.number(),
  totalVolume: z.number(),
  participantCount: z.number(),
});
export type CampaignVolumeData = z.infer<typeof CampaignVolumeDataSchema>;

/**
 * Response format for GET /campaigns endpoint
 * Maps campaign names to their volume statistics
 */
export const CampaignsStatsResponseSchema = z.record(z.string(), CampaignVolumeDataSchema);
export type CampaignsStatsResponse = z.infer<typeof CampaignsStatsResponseSchema>;
